import {Directive, ElementRef, Renderer2} from '@angular/core';

@Directive(
    {selector: '[appBaseOutsideClickScrollEventListener]'}
)
export class BaseOutsideClickScrollEventListenerDirective {


    public debugId: string;
    private debug = false; // Set to true to enable debug logs
    private removeScrollListenerFn: () => void;
    private removeClickListenerFn: () => void;

    constructor(protected renderer: Renderer2, protected elementRef: ElementRef) {
    }

    public registerOutsideClickListener(): void {
        // Register click listener if `onOutsideClick` is defined
        if (this.onOutsideClick) {
            const handleClick = (event: MouseEvent) => {
                if (!this.elementRef.nativeElement.contains(event.target)) {
                    this.onOutsideClick();
                }
            };
            if (this.debug) console.log('Registering click listener for outside clicks', this.debugId);
            this.removeClickListenerFn = this.renderer.listen('document', 'click', handleClick);
        }
    }

    public registerOnScrollListener(ignoredElement?: HTMLElement): void {
        // Register scroll listener if `onScroll` is defined
        if (this.onScroll) {
            const handleScroll = (event: Event) => {
                if (ignoredElement?.contains(event.target as Node))  {
                    return;
                }

                this.onScroll();
            };
            if (this.debug) console.log('Registering scroll listener', this.debugId);
            window.addEventListener('scroll', handleScroll, {capture: true});
            // define a cleanup function to remove the scroll listener
            this.removeScrollListenerFn = () => window.removeEventListener('scroll', handleScroll, {capture: true});
        }
    }

    public registerListeners(onScrollIgnoredElement?: HTMLElement): void {
        this.registerOutsideClickListener();
        this.registerOnScrollListener(onScrollIgnoredElement);
    }


    public removeClickListener(): void {
        if (this.removeClickListenerFn) {
            if (this.debug) console.log('Removing click listener for outside clicks', this.debugId);
            this.removeClickListenerFn(); // Calls the cleanup function returned by renderer.listen
        }
    }

    public removeOnScrollListener(): void {
        if (this.removeScrollListenerFn) {
            if (this.debug) console.log('Removing scroll listener', this.debugId);
            this.removeScrollListenerFn(); // Call the cleanup function to remove the listener
        }
    }

    public removeListeners(): void {
        this.removeClickListener();
        this.removeOnScrollListener();
    }


    // Optional methods to be implemented by subclasses
    public onOutsideClick?(): void;

    public onScroll?(): void;
}
